export default {
  companyLinks: [
    { key: 'about', label: 'About Envato', url: 'https://envato.com' },
    { key: 'careers', label: 'Careers', url: 'http://careers.envato.com' },
    {
      key: 'privacy',
      label: 'Privacy Policy',
      url: 'https://envato.com/privacy/'
    }
  ],
  infoLinks: [
    {
      key: 'envato',
      titleHtml: 'Envato Market',
      entries: [
        {
          key: 'terms',
          label: 'Terms',
          url: 'https://themeforest.net/legal/market'
        },
        {
          key: 'licenses',
          label: 'Licenses',
          url: 'https://themeforest.net/licenses'
        },
        { key: 'api', label: 'Market API', url: 'https://build.envato.com' },
        {
          key: 'affiliate',
          label: 'Become an affiliate',
          url: 'https://themeforest.net/affiliate_program'
        }
      ]
    },
    {
      key: 'help',
      titleHtml: 'Help',
      entries: [
        {
          key: 'themeTemplates',
          label: 'Themes and Templates',
          url: 'https://help.market.envato.com'
        },
        {
          key: 'websites',
          label: 'Websites',
          url: 'https://envatohosted.zendesk.com/hc/en-us'
        },
        {
          key: 'authors',
          label: 'Authors',
          url: 'https://help.market.envato.com/hc/en-us/categories/200216014'
        },
        {
          key: 'helpCenter',
          label: 'Help Center',
          url: 'https://help.market.envato.com'
        }
      ]
    },
    {
      key: 'community',
      titleHtml: 'Our Community',
      entries: [
        {
          key: 'community',
          label: 'Community',
          url: 'http://community.envato.com'
        },
        {
          key: 'blog',
          label: 'Blog',
          url: 'https://envato.com/blog'
        },
        {
          key: 'forums',
          label: 'Forums',
          url: 'https://forums.envato.com'
        },
        {
          key: 'meetups',
          label: 'Meetups',
          url: 'http://community.envato.com/#/events'
        }
      ]
    }
  ],
  socialMediaLinks: [
    {
      key: 'twitter',
      label: 'Twitter',
      url: 'https://twitter.com/envatomarket',
      icon: '/images/icon-twitter.svg'
    },
    {
      key: 'facebook',
      label: 'Facebook',
      url: 'https://www.facebook.com/envatomarket/',
      icon: '/images/icon-facebook.svg'
    },
    {
      key: 'youtube',
      label: 'YouTube',
      url: 'https://www.youtube.com/user/Envato',
      icon: '/images/icon-youtube.svg'
    },
    {
      key: 'instagram',
      label: 'Instagram',
      url: 'https://www.instagram.com/envato/',
      icon: '/images/icon-instagram.svg'
    },
    {
      key: 'pinterest',
      label: 'Pinterest',
      url: 'https://www.pinterest.com/envato/',
      icon: '/images/icon-pinterest.svg'
    }
  ]
}



// WEBPACK FOOTER //
// ./config/layout/footer.js